import React from "react"

export default function ReferralsAdd(){


    return(
        <>
             <h1>New referral BLOCK FORM</h1>
        </>
    )
}